<template>
    <div>
        <ul>
            <li
                v-for="(field, index) in displayDataObject"
                :key="`data_${field.name}_${index}`"
            >
                <dl v-if="field.value">
                    <dd>{{ xi18n(i8nPrefix, field.name) }}</dd>
                    <dt>{{ field.value }}</dt>
                </dl>
                <div v-else-if="field.items">
                    {{ xi18n(i8nPrefix, field.name) }}:
                    <display-data-object :displayDataObject="field.items" />
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'display-data-object',
        props: {
            displayDataObject: { type: [Object, Array], required: true },
            i8nPrefix: { type: String, default: '' }
        }
    };
</script>

<style scoped>
ul {
    margin-left: 8px;
}
</style>
